// extracted by mini-css-extract-plugin
export default {"referral":"ReferralIndicator_referral__96BGC","text":"ReferralIndicator_text__iYhEC"};